[
    {
        "promptKey": "pv-array-overview",
        "subject": "PV array",
        "shot": "Far-back system photo",
        "description": "Show every array clearly enough that the modules can be counted.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-main-switch-inverter-supply",
        "subject": "Switchboard",
        "shot": "Main switch inverter supply",
        "description": "Clear photo of the circuit-breaker rating at the switchboard.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-ac-isolator-rating",
        "subject": "Isolators",
        "shot": "AC isolator rating (if installed)",
        "description": "Capture the rating when an AC isolator is installed.",
        "appliesTo": "pv",
        "required": false
    },
    {
        "promptKey": "pv-dc-isolator-before",
        "subject": "Isolators",
        "shot": "PV array DC isolator - before",
        "description": "As found, including all MC4 connections into the inverter.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-dc-isolator-during",
        "subject": "Isolators",
        "shot": "PV array DC isolator - during",
        "description": "Show each string voltage.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-dc-isolator-after",
        "subject": "Isolators",
        "shot": "PV array DC isolator - after",
        "description": "Show the isolator and inverter inputs reinstated as originally found.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-inverter-far-back",
        "subject": "Inverter",
        "shot": "Inverter general view",
        "description": "Stand back far enough to show the inverter in context.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-inverter-left",
        "subject": "Inverter",
        "shot": "Left side of inverter",
        "appliesTo": "pv",
        "required": false
    },
    {
        "promptKey": "pv-inverter-right",
        "subject": "Inverter",
        "shot": "Right side of inverter",
        "appliesTo": "pv",
        "required": false
    },
    {
        "promptKey": "pv-inverter-model-details",
        "subject": "Inverter",
        "shot": "Inverter specification label",
        "description": "Clear photo of the inverter information label.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-inverter-serial",
        "subject": "Inverter",
        "shot": "Inverter serial number",
        "appliesTo": "pv",
        "required": false
    },
    {
        "promptKey": "pv-inverter-integrated-isolator",
        "subject": "Inverter",
        "shot": "Integrated isolator",
        "appliesTo": "pv",
        "required": false
    },
    {
        "promptKey": "pv-module-serial",
        "subject": "Solar panels",
        "shot": "Module serial number close-up",
        "description": "Prefer a serial photographed from the front of the panel rather than from the label.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "pv-module-model-details",
        "subject": "Solar panels",
        "shot": "Module make and model close-up",
        "description": "Photograph the underside label showing all electrical information and model number.",
        "appliesTo": "pv",
        "required": true
    },
    {
        "promptKey": "inverter-inverter-showing-ac-and-dc-isolators",
        "subject": "Inverter",
        "shot": "Inverter showing AC and DC isolators",
        "description": "Wide shot showing both AC and DC isolators near the inverter",
        "appliesTo": "pre-assembled-bs",
        "required": true
    },
    {
        "promptKey": "inverter-inverter-label-and-serial-number",
        "subject": "Inverter",
        "shot": "Inverter label and serial number",
        "description": "Legible label and serial number on the inverter nameplate",
        "appliesTo": "pre-assembled-bs",
        "required": true
    },
    {
        "promptKey": "inverter-inverter-mounting-screws-to-bracket",
        "subject": "Inverter",
        "shot": "Inverter mounting screws to bracket",
        "description": "Mounting screws attaching the inverter to its wall bracket",
        "appliesTo": "pre-assembled-bs",
        "required": true
    },
    {
        "promptKey": "inverter-inverter-frame-earthing-method",
        "subject": "Inverter",
        "shot": "Inverter frame earthing method",
        "description": "Earthing method for the inverter frame",
        "appliesTo": "pre-assembled-bs",
        "required": true
    },
    {
        "promptKey": "inverter-inverter-measurement-to-objects",
        "subject": "Inverter",
        "shot": "Inverter measurement to objects",
        "description": "Clearance measurements from the inverter to nearby objects",
        "appliesTo": "pre-assembled-bs",
        "required": true
    },
    {
        "promptKey": "isolators-battery-isolator-signage",
        "subject": "Isolators",
        "shot": "Battery isolator signage",
        "description": "Battery isolator signage / labelling",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "isolators-battery-load-breaker-disconnector-or-circuit-breaker-before-",
        "subject": "Isolators",
        "shot": "Battery load breaker disconnector or circuit breaker (before, during, after)",
        "description": "Before / during / after shots of the battery load-break disconnector or circuit breaker",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "isolators-dc-load-break-disconnectors",
        "subject": "Isolators",
        "shot": "DC load break disconnectors",
        "description": "DC load-break disconnectors",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "isolators-ac-isolators-before-during-after",
        "subject": "Isolators",
        "shot": "AC isolators (before, during, after)",
        "description": "Before / during / after shots of the AC isolators",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "inverter-inverter-shutdown-procedure",
        "subject": "Inverter",
        "shot": "Inverter shutdown procedure",
        "description": "Shutdown procedure printed near or on the inverter",
        "appliesTo": "pre-assembled-bs",
        "required": true
    },
    {
        "promptKey": "pv-array-pv-array-signage-additional-warning-signage",
        "subject": "PV array",
        "shot": "PV array signage & additional warning signage",
        "description": "PV array signage and any additional warning signage",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "general-close-up-photos-of-any-non-compliance-including-multi-glands",
        "subject": "General",
        "shot": "Close up photos of any non-compliance including multi-glands & HD conduit and PV conduit signage",
        "description": "Close-up photos of any non-compliance, including multi-glands, HD conduit, and PV conduit signage",
        "appliesTo": "all",
        "required": false
    },
    {
        "promptKey": "battery-system-battery-signage-on-hd-conduit-between-battery-and-inverter",
        "subject": "Battery system",
        "shot": "Battery signage on HD conduit between battery and inverter",
        "description": "Battery signage on the HD conduit running between battery and inverter",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-system-installation-location-at-distance-close-up",
        "subject": "Battery system",
        "shot": "Battery system installation location (at distance/ close-up)",
        "description": "Battery system installation location (at distance and close-up)",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-system-and-bollard",
        "subject": "Battery system",
        "shot": "Battery system and bollard",
        "description": "Battery system and any bollard / protective barrier",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-system-label-and-serial-number",
        "subject": "Battery system",
        "shot": "Battery system label and serial number",
        "description": "Battery system label and serial number — legible",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-modules-labels-and-serial-numbers",
        "subject": "Battery system",
        "shot": "Battery modules labels and serial numbers",
        "description": "Battery modules labels and serial numbers",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-frame-earthing-method",
        "subject": "Battery system",
        "shot": "Battery frame earthing method",
        "description": "Earthing method for the battery frame",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-mounting-screws-to-brackets",
        "subject": "Battery system",
        "shot": "Battery mounting screws to brackets",
        "description": "Mounting screws attaching the battery to its brackets",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-measurements-to-objects-side-below-top",
        "subject": "Battery system",
        "shot": "Battery measurements to objects (side, below, top)",
        "description": "Clearance measurements from the battery to nearby objects (side, below, top)",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-system-internal-cabling",
        "subject": "Battery system",
        "shot": "Battery system internal cabling",
        "description": "Battery system internal cabling",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-sign-label",
        "subject": "Battery system",
        "shot": "Battery sign label",
        "description": "Battery sign / general labelling",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-shutdown-procedure-signage",
        "subject": "Battery system",
        "shot": "Battery shutdown procedure signage",
        "description": "Battery shutdown procedure signage",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-danger-risk-of-battery-explosion-signage",
        "subject": "Battery system",
        "shot": "Battery 'danger risk of battery explosion' signage",
        "description": "Battery 'danger risk of battery explosion' signage",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-danger-toxic-fumes-signage",
        "subject": "Battery system",
        "shot": "Battery 'danger toxic fumes' signage",
        "description": "Battery 'danger toxic fumes' signage",
        "appliesTo": "all",
        "required": true
    },
    {
        "promptKey": "battery-system-battery-danger-arc-flash-hazard-signage-if-applicable",
        "subject": "Battery system",
        "shot": "Battery 'danger arc flash hazard' signage (if applicable)",
        "description": "Battery 'danger arc flash hazard' signage — capture if the system has the hazard",
        "appliesTo": "all",
        "required": false
    }
]
